export default {
  'NewTube': {
    rootUrl: '/tube',
    text: 'LinkUp',
    authName: 'Tube',
    activePathRegExp: /^\/tube/i,
    excludePathRegExp: null,
    sort: 1,
  },
  'TA': {
    rootUrl: '/ta',
    text: 'Attendance',
    authName: 'Ta',
    activePathRegExp: /^\/ta/i,
    excludePathRegExp: null,
    sort: 2,
  },
  'Foundation': {
    rootUrl: '/Foundation',
    text: 'Foundation',
    authName: 'Foundation',
    activePathRegExp: /^\/foundation/i,
    excludePathRegExp: null,
    sort: 3,
  },
  'PY': {
    rootUrl: '/payroll',
    text: 'Payroll',
    authName: 'Pr',
    activePathRegExp: /^\/payroll/i,
    excludePathRegExp: null,
    sort: 4,
  },
  'RMS': {
    rootUrl: '/rms',
    text: 'Recruitment',
    authName: 'Rms',
    activePathRegExp: /^\/rms/i,
    excludePathRegExp: null,
    sort: 5,
  },
  Dashboard: {
    rootUrl: '/dashboard',
    text: 'Dashboard',
    authName: 'Dashboard',
    activePathRegExp: /^\/dashboard/i,
    excludePathRegExp: null,
    sort: 6,
  },
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/configs/modules.js
 **/